<template>
  <div class="resume-page">

    <!-- ========== HEADER ========== -->
    <div class="resume-header">
      <v-icon class="resume-header__back" @click="changePage">mdi-arrow-left</v-icon>
      <span class="resume-header__title">
        {{ spaceSelected.name }}
      </span>
    </div>
    <v-divider />

    <!-- ========== BODY ========== -->
    <div class="resume-body">
      <router-view></router-view>
      
      <v-row no-gutters>
        <!-- Left column: 4 cards in 2x2 grid -->
        <v-col cols="12" md="8" lg="9">
          <v-row no-gutters>
            <v-col cols="12" md="6" class="pa-2">
              <div class="resume-card">
                <QueuesList></QueuesList>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="pa-2">
              <div class="resume-card">
                <StandsList></StandsList>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="pa-2">
              <div class="resume-card">
                <widgetTicketsByQueue></widgetTicketsByQueue>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="pa-2">
              <div class="resume-card">
                <widgetTotalTicketsBySpace></widgetTotalTicketsBySpace>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <!-- Right column: Contents card -->
        <v-col cols="12" md="4" lg="3" class="pa-2">
          <div class="resume-card">
            <CreateContents></CreateContents>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import router from "vue-router";
import RightMenuAddNewQueue from "@/components/RightMenuAddNewQueue.vue";
import RightMenuEditQueue from "@/components/RightMenuEditQueue.vue";
import CreateContents from "@/components/CreateContents.vue";
import StandsList from "@/components/StandsList.vue";
import QueuesList from "@/components/QueuesList.vue";
import widgetTicketsByQueue from "@/components/widgetTicketsByQueue.vue";
import widgetTotalTicketsBySpace from "@/components/widgetTotalTicketsBySpace.vue";

export default {
  name: "ResumeSpace",
  components: {
    RightMenuAddNewQueue,
    RightMenuEditQueue,
    CreateContents,
    StandsList,
    QueuesList,
    widgetTicketsByQueue,
    widgetTotalTicketsBySpace
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["actualProject", "firstProject"]),

    ...mapState("queues", [
      "spaceSelected",
      "allResouces",
      "objQueueCont",
      "objQueueContKiosk",
      "allQueues",
      "RightMenuAddNewQueue",
      "showRightMenu",
      "allSpaces",
      "RightMenuEditQueue",
    ]),

  },
  methods: {
    ...mapMutations("queues", ["setActualSpaceMutation"
    ]),
    ...mapActions("queues", [
      "getAllQueues",
      "getAllSpaces",
      "getAllResouces",
      "getTicketsInfoByQueueAndSpace",
      "getTicketsInfoBySpace"
    ]),
    changePage() {
        this.$router.push({
            name: "ListSpaces",
        });
    },
  },

  async created() {

    let idProject = "";
    if (this.actualProject == undefined) {
      idProject = this.firstProject.id;
    } else {
      idProject = this.actualProject.id;
    }

    await this.getTicketsInfoByQueueAndSpace(this.spaceSelected.idSpace);
    await this.getTicketsInfoBySpace(this.spaceSelected.idSpace);
  },
  destroyed() {},
};
</script>

<style scoped>
.resume-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  background: #f5f5f5;
}
.resume-header {
  display: flex;
  align-items: center;
  background-color: #fff;
  min-height: 50px;
  padding: 0 16px;
}
.resume-header__back {
  cursor: pointer;
  flex-shrink: 0;
}
.resume-header__title {
  margin-left: 12px;
  font-size: 18px;
  color: #777;
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.resume-body {
  flex: 0 0 auto;
  padding: 20px 28px;
}
.resume-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 14px;
  overflow: hidden;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/desktop/ResumeSpace.vue